import React from 'react';
import './ErrorMessageList.css';

const ErrorMessageList = ({ title = 'Please fix the following:', errors = [] }) => {
  if (!Array.isArray(errors) || errors.length === 0) {
    return null;
  }

  return (
    <div className="error-message-list" role="alert">
      <p className="error-list-title">{title}</p>
      <ul>
        {errors.map((error, index) => (
          <li key={`${error}-${index}`}>{error}</li>
        ))}
      </ul>
    </div>
  );
};

export default ErrorMessageList;
